// extracted by mini-css-extract-plugin
module.exports = {"esTableContainer":"escalationMatrix_esTableContainer__t4Y+F","esTable":"escalationMatrix_esTable__aYJqT","esTableRow":"escalationMatrix_esTableRow__7lSZ/"};